import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
} from "recharts";

const MonthlyGstChart = ({ data }) => {
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white border-0">
        <h5 className="mb-0">Monthly GST Collected</h5>
      </div>

      <div className="card-body">
        <ResponsiveContainer width="100%" height={320}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="month" />

            <YAxis />

            <Tooltip
              formatter={(value) =>
                `₹${Number(value).toLocaleString("en-IN")}`
              }
            />

            <Line
              type="monotone"
              dataKey="gst"
              stroke="#198754"
              strokeWidth={3}
              dot={{ r: 6 }}
              activeDot={{ r: 8 }}
            >
              <LabelList
                dataKey="gst"
                position="top"
                formatter={(value) => `₹${Number(value).toLocaleString("en-IN")}`}
              />
            </Line>
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MonthlyGstChart;
